module.exports = __webpack_public_path__ + "media/giving-back/circular-446be6b7.webp";